export default [
  {
    path: 'stok',
    name: 'product check stock',
    component: () => import('@/views/app/product/check-stock/page-list.vue'),
    meta: { title: 'Cek Stok Produk' },
  },
  {
    path: 'kartu-stok',
    name: 'product stock card',
    component: () => import('@/views/app/product/stock-card/page-list.vue'),
    meta: { title: 'Kartu Stok Produk' },
  },
]
